import AutoFillDetail from './AutoFillDetail'
import { connect } from "react-redux";
import * as promotionActions from "../../../../../actions/promotionAction";
import { withRouter } from 'react-router';

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAutoFill: (id) => dispatch(promotionActions.getListAutoFill(id)),
        getAllCampaign: () => dispatch(promotionActions.getAllCampaign()),
        getAllCampaignsFilter: (filters) => dispatch(promotionActions.getAllCampaignFilter(filters)),
        getListPromotions: (filters) => dispatch(promotionActions.getListPromotions(filters)),
        createAutoFill: (autoFill) => dispatch(promotionActions.createAutoFill(autoFill)),
        getAutoFillDetails: (id) => dispatch(promotionActions.getAutoFillDetails(id)),
        updateAutoFill: (autoFill) => dispatch(promotionActions.updateAutoFill(autoFill)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AutoFillDetail))
